var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticStyle: { "z-index": "600" },
      attrs: {
        "content-class": "paymentDialog",
        persistent: "",
        "max-width": "800",
        light: true,
      },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c(
            "v-card",
            { staticStyle: { "min-height": "500px" } },
            [
              _c("div", { staticClass: "spacer-25" }),
              _c(
                "h1",
                {
                  staticClass: "mt-4 text-center",
                  staticStyle: { padding: "0 24px" },
                },
                [_vm._v("Zu zahlender Gesamtbetrag:")]
              ),
              _c("div", { staticClass: "spacer-40" }),
              _c("h1", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
              ]),
              _c("v-card-text", [
                _c("div", { staticClass: "spacer-40" }),
                _c("div", { staticClass: "spacer-40" }),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _vm.terminalInstructions
                      ? [
                          _c("div", { staticClass: "text-center" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "blink-border pa-10 ml-5 mr-5 d-inline-block",
                              },
                              [
                                _c("h2", [
                                  _vm._v(_vm._s(_vm.terminalInstructions)),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      : [
                          _c("h2", [
                            _vm._v("Bitte bezahle jetzt am Kartenterminal"),
                          ]),
                        ],
                  ],
                  2
                ),
                _c("div", { staticClass: "mt-10" }, [
                  _c("div", { staticClass: "spacer-40" }),
                  _c("div", { staticClass: "spacer-40" }),
                  _c("div", { staticClass: "spacer-40" }),
                  _c("div", { staticClass: "spacer-40" }),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }